var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RefreshTokenExpiredError, TokenError, TokenExpiredError, HTTPError, } from "../errors.js";
/**
 * This is the error that's thrown by the client being used to send the information
 */
export class ClientError extends Error {
}
/**
 * Thrown when multiple retry attempts has been exhausted
 */
export class FailedAfterRetryError extends Error {
    constructor(lastCause) {
        super(`failed after multiple attempts`);
        this.cause = lastCause;
        this.name = "FailedAfterRetryError";
    }
}
export const throwError = function (res) {
    return __awaiter(this, void 0, void 0, function* () {
        const err = yield res.json();
        // console.log("throwError", err);
        if (err.code === "auth/expired" && res.status === 401) {
            throw new TokenExpiredError(res.status);
        }
        if (err.code === "auth/invalid-token" && res.status === 401) {
            throw new TokenError(res.status);
        }
        if (err.message === "authentication token expired" && res.status === 401) {
            throw new RefreshTokenExpiredError(res.status);
        }
        throw new HTTPError(res.status, err);
    });
};
